/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible separator characters.
 */
export type SeparatorType = SeparatorTypeComma | SeparatorTypeSemicolon | SeparatorTypeSpace;

/**
 * The comma separator type.
 */
export type SeparatorTypeComma = typeof SEPARATOR_TYPE_COMMA;

/**
 * The space separator type.
 */
export type SeparatorTypeSpace = typeof SEPARATOR_TYPE_SPACE;

/**
 * The semicolon separator type.
 */
export type SeparatorTypeSemicolon = typeof SEPARATOR_TYPE_SEMICOLON;

/**
 * The comma separator constant.
 */
export const SEPARATOR_TYPE_COMMA = `,`;

/**
 * The semicolon separator constant.
 */
export const SEPARATOR_TYPE_SEMICOLON = `;`;

/**
 * The space separator constant.
 */
export const SEPARATOR_TYPE_SPACE = ` `;
